var _defs, _path, _ellipse, _ellipse2, _path2, _ellipse3, _ellipse4, _path3, _ellipse5, _ellipse6, _path4, _ellipse7, _ellipse8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77 5.636v10.838M28.18 5.636v10.838M66.33 5.636v10.838M42.92 5.636v10.838M35.549 5.636v10.838",
    stroke: "#050505"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.474,
    cy: 11.055,
    rx: 4.335,
    ry: 5.419,
    stroke: "#03BCAA",
    strokeDasharray: "2.6 1.73"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.624,
    cy: 11.055,
    rx: 4.335,
    ry: 5.419,
    stroke: "#03BCAA",
    strokeDasharray: "2.6 1.73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77 22.977v10.838M12.139 22.977v10.838M66.33 22.977v10.838M58.959 22.977v10.838M19.508 22.977v10.838",
    stroke: "#050505"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.214,
    cy: 28.396,
    rx: 4.335,
    ry: 5.419,
    stroke: "#03BCAA",
    strokeDasharray: "2.6 1.73"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.255,
    cy: 28.396,
    rx: 4.335,
    ry: 5.419,
    stroke: "#03BCAA",
    strokeDasharray: "2.6 1.73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77 40.318v10.838M11.705 40.318v10.838M48.121 40.318v10.838M41.185 40.318v10.838M34.248 40.318v10.838",
    stroke: "#050505"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.978,
    cy: 45.737,
    rx: 4.335,
    ry: 5.419,
    stroke: "#03BCAA",
    strokeDasharray: "2.6 1.73"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.394,
    cy: 45.737,
    rx: 4.335,
    ry: 5.419,
    stroke: "#03BCAA",
    strokeDasharray: "2.6 1.73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.809 57.659v10.838M28.18 57.659v10.838M66.33 57.659v10.838M58.959 57.659v10.838M51.59 57.659v10.838",
    stroke: "#050505"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.105,
    cy: 63.078,
    rx: 4.335,
    ry: 5.419,
    stroke: "#03BCAA",
    strokeDasharray: "2.6 1.73"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.884,
    cy: 63.078,
    rx: 4.335,
    ry: 5.419,
    stroke: "#03BCAA",
    strokeDasharray: "2.6 1.73"
  })));
}

var MemoSvgInformation = /*#__PURE__*/React.memo(SvgInformation);
export default "data:image/svg+xml;base64,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";
export { MemoSvgInformation as ReactComponent };